import React, {Fragment} from "react";
import {Box} from "@mui/material";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {HashLink} from "react-router-hash-link";
import {getHomeInternalUrl} from "../../constants/appRoutes";
import Footer from "../footer";
import Header from "../header";
import Hero from "../hero";
import Page from "../page";
import {configSelector} from "../../state/config/configSelectors";
import {hubSelector} from "../../state/hub/hubSelectors";
import {getPageTitle} from "../../utils/other";

const PageNotFound = ({defaultNode}) => {
  const {t, i18n} = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const hub = useSelector(hubSelector);
  const config = useSelector(configSelector);

  return (
    <Fragment>
      <HashLink to={{hash: "#main", search: location.search}} className="skip-link sr-only">
        {t("commons.hashLinks.main")}
      </HashLink>
      <HashLink to={{hash: "#footer", search: location.search}} className="skip-link sr-only">
        {t("commons.hashLinks.footer")}
      </HashLink>
      <Page
        title={getPageTitle(
          [
            i18n.exists("scenes.pageNotFound.title") ? t("scenes.pageNotFound.title") : "Pagina non trovata",
            hub?.hub?.name
          ],
          t
        )}
      >
        <Header />
        <Box
          component="main"
          id="main"
          sx={{
            width: "100%",
            height: "100%",
            position: "fixed",
            display: "flex",
            flexDirection: "column",
            "& #footer": {
              paddingTop: "0px"
            }
          }}
        >
          <Hero
            title={
              i18n.exists("scenes.pageNotFound.text.main") ? t("scenes.pageNotFound.text.main") : "Pagina non trovata"
            }
            slogan={
              i18n.exists("scenes.pageNotFound.text.secondary")
                ? t("scenes.pageNotFound.text.secondary")
                : "La risorsa che stai cercando potrebbe essere stata spostata, rinominata o non è più disponibile.\nTi invitiamo a tornare alla home page per continuare la navigazione."
            }
            background={defaultNode ? defaultNode?.backgroundMediaURL : hub?.backgroundMediaURL}
            backgroundFallback={
              defaultNode ? (
                <div
                  style={{
                    background: `url("${config.clientBasePath}/config/images/default-node-background.jpg") center center / cover no-repeat`
                  }}
                />
              ) : null
            }
          >
            <Button
              id="error-page__button"
              color="secondary"
              variant="contained"
              onClick={() => {
                navigate(getHomeInternalUrl());
                window.location.reload();
              }}
            >
              {i18n.exists("scenes.pageNotFound.button") ? t("scenes.pageNotFound.button") : "Vai alla homepage"}
            </Button>
          </Hero>
          <Footer />
        </Box>
      </Page>
    </Fragment>
  );
};

export default PageNotFound;
